import { Footer } from '@finn/ua-footer';

export default Footer;
